import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Inject,
  Input
} from '@angular/core';
import { CookieHeightChangeService } from './cookie-height-change.service';
import { CookieConsentService } from './cookie-consent.service';
import { AgencyService } from '../../api/agency.service';
import { LocaleService } from './../../seo/locale.service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})

export class CookieComponent implements AfterViewInit {
  @ViewChild('cookie') cookie: ElementRef;
  @Input() canDecline: boolean = true;

  constructor(
    @Inject('WINDOW') private window: any,
    public localeService: LocaleService,
    public agencyService: AgencyService,
    public cookieConsentService: CookieConsentService,
    private cookieHeightChangeService: CookieHeightChangeService
  ) { }

  ngAfterViewInit(): void {
    if (this.window) {
      this.onResize();
      this.cookieHeightChangeService.openCloseCookie.subscribe(
        open => open ? this.openCookie() : null
      );
    }
  }

  closeCookie(): void {
    this.cookie.nativeElement.style.height = '0px';
    this.cookieHeightChangeService.setCookieHeight(0);
  }

  openCookie(): void {
    this.cookie.nativeElement.style.height = 'auto';
    this.cookie.nativeElement.style.height = (this.cookie.nativeElement.offsetHeight + 19) + 'px';
    this.cookieHeightChangeService.setCookieHeight(this.cookie.nativeElement.offsetHeight);
  }

  onResize(): void {
    if (this.cookieConsentService.getConsent() === true)
      this.closeCookie();
    else
      this.openCookie();
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/utils/cookie/cookie.component.ts